export default "__VITE_ASSET__CS19Jq8C__"